import styled from 'styled-components';
import theme from 'meta/theme';
import Box from './Box';

const SimpleCard = styled(Box)`
	display: flex;
	flex-direction: column;

	text-align: left;

	text-decoration: none;

	background: ${theme.palette.primary.main};
	padding: ${theme.spacing(1)}px ${theme.spacing(2)}px;
	border-radius: 3px;

	margin: ${theme.spacing(2)}px;

	&:hover {
		cursor: pointer;
	}
	&:hover > * {
		color: ${theme.palette.secondary.main};
		transition: color 0.2s ease-out;
	}
`;

export default SimpleCard;
